import { useLayoutEffect, useRef, useState } from 'react'

export const useViewportFit = (offset = { }) => {
  const ref = useRef()
  const [hasTopConflict, setHasTopConflict] = useState(false)
  const [hasRightConflict, setHasRightConflict] = useState(false)
  const [hasBottomConflict, setHasBottomConflict] = useState(false)
  const [hasLeftConflict, setHasLeftConflict] = useState(false)

  const detectConflicts = () => {
    if (!ref.current) {
      if (hasTopConflict) setHasTopConflict(false)
      if (hasRightConflict) setHasRightConflict(false)
      if (hasBottomConflict) setHasBottomConflict(false)
      if (hasLeftConflict) setHasLeftConflict(false)
      return
    }

    const { top, right, bottom, left } = ref.current.getBoundingClientRect()
    const { innerHeight } = window
    const { clientWidth } = document.body

    const newHasTopConflict = Math.round(top) - (offset?.top || 0) < 0
    if (newHasTopConflict && !hasTopConflict) setHasTopConflict(true)
    const newHasRightConflict = Math.round(right) + (offset?.right || 0) > clientWidth
    if (newHasRightConflict && !hasRightConflict) setHasRightConflict(true)
    const newHasBottomConflict = Math.round(bottom) + (offset?.bottom || 0) > innerHeight
    if (newHasBottomConflict && !hasBottomConflict) setHasBottomConflict(true)
    const newHasLeftConflict = Math.round(left) - (offset?.left || 0) < 0
    if (newHasLeftConflict && !hasLeftConflict) setHasLeftConflict(true)
  }

  useLayoutEffect(detectConflicts)

  return {
    ref,
    topConflict: hasTopConflict,
    rightConflict: hasRightConflict,
    bottomConflict: hasBottomConflict,
    leftConflict: hasLeftConflict
  }
}
